type Props = {};

// a function to be used with react-router-dom 'link' component by calling this as an onClick on parent container
export const scrollToTop = (props: Props) => {
  window.scrollTo(0, 0);
  return;
};